export default __webpack_public_path__ + "static/media/quiz@2x.09bc783d.png";